"use strict";
/********************************************************************************
  HxNativeInteropMessageBridge.ts

  Interface to be implemented by HxCore consumer to abstract the bridging
  to native code.  HxCore requires a single generic Send/Receive pipeline

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
